module.exports = __webpack_public_path__ + "img/watermark-example.42614ac2.png";